const translations = {
    asAppliedMap: 'As Applied Map',
    asCovered: 'As Covered',
    resourceName: 'As Applied Map'
};

export default translations;
